import { ReactNode } from 'react'

export type GroupedListGroup<T> = {
  id: string | number
  title: ReactNode
  items: T[]
}

export type GroupedListProps<T> = {
  groups: GroupedListGroup<T>[]
  renderGroupHeader?: (group: GroupedListGroup<T>) => ReactNode
  renderItem: (item: T, group: GroupedListGroup<T>) => ReactNode
  itemKey?: (item: T, group: GroupedListGroup<T>) => string | number
  emptyContent?: ReactNode
  wrapperClassName?: string
  groupClassName?: string
  itemClassName?: string
}

export const GroupedList = <T,>({
  groups,
  renderGroupHeader,
  renderItem,
  itemKey,
  emptyContent,
  wrapperClassName = 'mb-8',
  groupClassName = 'mb-4',
  itemClassName = 'list-group-item d-flex justify-content-between align-items-center',
}: GroupedListProps<T>): JSX.Element | null => {
  if (!groups.length) {
    return <>{emptyContent || null}</>
  }

  return (
    <div className={wrapperClassName}>
      {groups.map((group) => (
        <div key={group.id} className={groupClassName}>
          <div className='d-flex justify-content-between align-items-center mb-2'>
            {renderGroupHeader ? renderGroupHeader(group) : <strong>{group.title}</strong>}
          </div>
          <div className='list-group'>
            {group.items.map((item, index) => (
              <div key={itemKey ? itemKey(item, group) : index} className={itemClassName}>
                {renderItem(item, group)}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
